import { theme } from 'antd';
import { EditIcon } from 'assets/images/svg';
import { constants } from 'config/constants';
import { useManagePermittedRoles } from 'library/hooks';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { selectDevicesByDeviceID } from 'reduxStore/devices/selectors';
import ManageDeviceCredentialsModal from 'zComponents/molecules/ManageDeviceCredentialsModal';
import { Button, Col, Row, Tooltip } from 'zui/Antd';

const { INNER_RANGE_DEVICE_CATEGORIES } = constants;

const CredentialPanelExtra = ({ deviceID, activeKeys, setActiveKeys, onModalOpenChange }) => {
	const {
		token: { colorTextLabel }
	} = theme.useToken();
	const canUpdateCredential = useManagePermittedRoles('updateCredential');
	const permissionDeniedMessage = "You don't have permission to perform this action.";

	const device = useSelector((state) => selectDevicesByDeviceID(state, deviceID));
	const [openModal, setOpenModal] = useState(false);

	// ✅ Only show for card-based devices (not IR)
	const isIR = INNER_RANGE_DEVICE_CATEGORIES.includes(device?.defaultCategoryID);
	const isCardBased = !isIR;

	if (!isCardBased) return null;

	const handleOpenModal = (e) => {
		e.stopPropagation();
		if (!canUpdateCredential) return;
		setOpenModal(true);
		onModalOpenChange?.(true);
		if (!activeKeys.includes('credentials')) {
			setActiveKeys([...activeKeys, 'credentials']);
		}
	};

	const handleCloseModal = () => {
		setOpenModal(false);
		onModalOpenChange?.(false);
		setTimeout(() => {
			setActiveKeys((prev) => {
				if (!prev.includes('credentials')) {
					return [...prev, 'credentials'];
				}
				return prev;
			});
		}, 10);
	};

	return (
		<Row align='middle' gutter={[8, 8]}>
			<Col>
				<Tooltip title={!canUpdateCredential ? permissionDeniedMessage : ''}>
					<span>
						<Button
							type='text'
							size='small'
							icon={<EditIcon color='currentColor' />}
							onClick={handleOpenModal}
							disabled={!canUpdateCredential}
							style={{ color: colorTextLabel, fontSize: 18 }}
						/>
					</span>
				</Tooltip>
			</Col>
			<ManageDeviceCredentialsModal visible={openModal} setVisible={handleCloseModal} deviceID={deviceID} />
		</Row>
	);
};

export default CredentialPanelExtra;
